export default __webpack_public_path__ + "static/media/hht2_ep20_book_wp_01.5c56fb51.jpg";